// extracted by mini-css-extract-plugin
export default {"accepted":"ConsentStatus_accepted__M0mYv","declined":"ConsentStatus_declined__YRcxE","withdrawn":"ConsentStatus_withdrawn__vQqOh"};